import { Box, makeStyles, Typography } from '@material-ui/core';
import { colors } from '../../../styles/theme';
import { MOBILE_BREAKPOINT } from '../../../utils/utilityHelper';
import { ReactElement, useContext, useEffect, useState } from 'react';
import { Units } from '@turf/helpers';
import _ from 'lodash';
import { calculateMeasurement } from './measurementUtils';
import { LanguageContext } from '../../../contexts/LanguageContext/languageContext';
import { useRecoilValue } from 'recoil';
import { configState } from '../../../recoil/atoms';

interface Props {
  header: ReactElement;
  lineString: GeoJSON.LineString | null | undefined;
  isMobileView: boolean;
}
export interface measurementDataProps {
  segments: number;
  measurement: number;
  configUnits: Units;
  unitsAbbreviation: string;
}
const TGLineSidebar = ({ header, lineString, isMobileView }: Props) => {
  const classes = useStyles();
  const [measurementData, setMeasurementData] = useState<measurementDataProps | null>(null);
  const { geographic } = useRecoilValue(configState);
  const { translate } = useContext(LanguageContext);

  useEffect(() => {
    const data = calculateMeasurement(lineString, geographic);
    setMeasurementData(data as measurementDataProps);
  }, [lineString, geographic]);

  if (!measurementData) return null;
  const { segments, measurement, unitsAbbreviation, configUnits } = measurementData;
  return (
    <Box className={classes.container}>
      {!isMobileView && header}
      <Box className={classes.innerContainer}>
        <Box className={classes.segmentContainer}>
          <Typography className={classes.txt}>{translate('Number of Segment(s)')}</Typography>
          <Box className={classes.badge}>
            <Typography className={classes.badgeTxt}>{segments}</Typography>
          </Box>
        </Box>
        <Box className={classes.segmentContainer}>
          <Typography className={classes.txt}>
            {`${translate('Total $__CONFIG_UNITS__$ ($__UNITS_ABBREVIATION__$)', {
              CONFIG_UNITS: _.capitalize(configUnits),
              UNITS_ABBREVIATION: unitsAbbreviation,
            })}`}
          </Typography>
          <Box className={classes.badge}>
            <Typography className={classes.badgeTxt}>{`${measurement} ${translate(configUnits)}`}</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  container: {
    height: '100%',
    width: 400,
    [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
      width: '100%',
    },
  },
  innerContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    padding: '22px 30px',
    [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
      padding: 22,
    },
  },
  segmentContainer: {
    border: `1px solid ${colors.black10}`,
    borderRadius: 8,
    backgroundColor: colors.white,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '9px 16px',
    [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
      padding: '10px 16px',
    },
  },
  txt: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 'normal',
    color: colors.black0,
  },
  badge: {
    backgroundColor: colors.ghostWhite,
    border: `1px solid ${colors.black10}`,
    borderRadius: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '3px 10px',
  },
  badgeTxt: {
    fontSize: 15,
    fontWeight: 400,
    lineHeight: 'normal',
  },
}));

export default TGLineSidebar;
